const setTitle = (title: string) => {
  document.title = title + ' | Imago Dashboard'
}

export { setTitle }
